module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "rating",
    attrs: {
      "summary": "",
      "cellpadding": "4",
      "cellspacing": "0",
      "id": _vm.field.name
    }
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v(" ")]), _vm._v(" "), _vm._l((_vm.field.values), function(rate) {
    return _c('th', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.isValueHidden(rate.value)),
        expression: "!isValueHidden(rate.value)"
      }],
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('label', {
      attrs: {
        "for": _vm.field.name + '_' + rate.value
      }
    }, [_vm._v(_vm._s(rate.label))])])
  }), _vm._v(" "), _c('th', [_vm._v(" ")])], 2), _vm._v(" "), _c('tr', {
    staticStyle: {
      "border-top": "1px solid #aaadb0"
    }
  }, [_c('td', [_c('label', [_vm._v(_vm._s(_vm.field.minText))])]), _vm._v(" "), _vm._l((_vm.field.values), function(rate) {
    return _c('td', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.isValueHidden(rate.value)),
        expression: "!isValueHidden(rate.value)"
      }],
      staticStyle: {
        "text-align": "center"
      }
    }, [_c('input', {
      directives: [{
        name: "validate",
        rawName: "v-validate",
        value: ({
          required: _vm.required && !_vm.field.hide
        }),
        expression: "{required: required && !field.hide}"
      }],
      staticClass: "form-radio",
      attrs: {
        "type": "radio",
        "name": _vm.field.name,
        "data-vv-as": _vm.field.description.replace(/\./g, ''),
        "disabled": _vm.locked,
        "title": "1",
        "id": _vm.field.name + '_' + _vm.field.value
      },
      domProps: {
        "value": rate.value
      },
      on: {
        "change": function($event) {
          return _vm.$emit('input', rate.value)
        }
      }
    })])
  }), _vm._v(" "), _c('td', [_c('label', [_vm._v(_vm._s(_vm.field.maxText))])])], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f8b6fa96","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/formbuilder/render/RatingRender.vue
// module id = 1762
// module chunks = 1